// shared slot-name constants for template block ids.. each <Template>.tsx file and its
// default-blocks.ts builder reference the same keys here instead of literal strings, so a typo
// fails to compile instead of silently missing a match
export const BLOCK_ID = {
  headerLogo: 'header-logo',
  badge: 'badge',
  salutation: 'salutation',
  title: 'title',
  mainImage: 'main-image',
  description: 'description',
  dateTimeCard: 'date-time-card',
  infoCard: 'info-card',
  infoList: 'info-list',
  countdownBadge: 'countdown-badge',
  cta: 'cta',
  topBar: 'top-bar',
  accentBar: 'accent-bar',
  divider: 'divider',
  divider1: 'divider-1',
  divider2: 'divider-2',
  divider3: 'divider-3',
  divider4: 'divider-4',
  social: 'social',
  tagline: 'tagline',
  supportText: 'support-text',
  communityText: 'community-text',
  legalText: 'legal-text',
  mailingAddress: 'mailing-address',
} as const;
